import { FunctionComponent } from "react";
import { Navbar } from "@App/Components/Navbar";
import { Footer } from "@App/Layouts/Footer";
import { Outlet } from "react-router-dom";

export const Layout: FunctionComponent = () => {
  return (
    <div className="text-neutral-900">
      <Navbar>
        <div className={"flex items-center gap-5"}>
          <img src="/images/brand/db.svg" className={"h-8"} alt="DBconnect" />
        </div>
        <div className={"flex"}>
          <a
            href={"https://www.repareo.de"}
            className={"flex"}
            title={"repareo Werkstattvergleich"}
          >
            <img src="/images/brand/logoBlack.svg" className="w-28 h-auto" alt="" />
          </a>
        </div>
      </Navbar>
      <Outlet />
      <Footer />
    </div>
  );
};
